import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DecimalPipe, CurrencyPipe } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';

import { TrSpinnerButtonDirectiveModule } from '@toro/common/shared/directives/tr-spinner-button/tr-spinner-button.module';
import { ViewinterceptorDirectiveModule } from '@toro/common/shared/directives/view-interceptor/view-interceptor.module';
import { ElementCardsDirectiveModule } from '@toro/common/shared/directives/element-cards/element-cards.module';
import { TooltipDirectiveModule } from '@toro/common/shared/directives/tooltip/tooltip.module';
import { IfCblcDirectiveModule } from '@toro/common/shared/directives/if-cblc/if-cblc.module';

import { FirstNamePipeModule } from '@toro/common/shared/pipes/first-name/fisrt-name.module';
import { IntDatePipeModule } from '@toro/common/shared/pipes/int-date/int-date.module';
import { MarkdownToHtmlPipeModule } from '@toro/common/shared/pipes/markdown/markdown.module';
import { DateISOStringPipeModule } from '@toro/common/shared/pipes/date-iso-string/date-iso-string.module';

import { OverlaySimpleModule } from '@toro/common/shared/components/dialogs/overlay-simple/overlay-simple.module';
import { FooterModule } from '@toro/common/shared/components/footer/footer.module';
import { TrLoadingOverlayModule } from '@toro/common/shared/components/tr-loading-overlay/tr-loading-overlay.module';
import { TrStepInputModule } from '@toro/common/shared/components/tr-step-input/tr-step-input.module';
import { TrAccordionModule } from '@toro/common/shared/components/tr-accordion/tr-accordion.module';
import { TrCheckboxModule } from '@toro/common/shared/components/tr-forms-inputs/tr-checkbox/tr-checkbox.module';
import { TrMoneyModule, ModalModule } from '@toro/common/shared/components';
import { TrPlannedCheckoutInputModule } from '@toro/common/shared/components/tr-planned-checkout-input/tr-planned-checkout-input.module';
import { TrConfirmButtonsModule } from '@toro/common/shared/components/tr-confirm-buttons/tr-confirm-buttons.module';
import { AlertMessageModule } from '@toro/common/shared/components/alert-message/alert-message.module';
import { HubNavModule } from '@toro/common/shared/components/hub-nav/hub-nav.module';
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';
import { TrWrapperTwoColumnsModule } from '@toro/common/shared/components/tr-wrapper-two-columns/tr-wrapper-left-column.module';
import { HubLogoModule } from '@toro/common/shared/components/hub-logo/hub-logo.module';
import { ArrowBackLinkModule } from '@toro/common/shared/components/backlink/arrow-link/arrow-link.module';

import { RouterModule } from '@angular/router';

import { StockHomeComponent } from './stockhome/stockhome.component';
import { DialogVideoComponent } from './dialogs/dialog-video/dialog-video.component';
import { StocksMarketInteractionsService } from './services/stocks-market-interactions.service';
import { PlannedCheckoutComponent } from './checkout/planned-checkout/planned-checkout.component';
import { TrWarrantyUsageComponent } from './checkout/common/tr-warranty-usage/tr-warranty-usage.component';
import { InvestmentResumeComponent } from './checkout/dialogs/investment-resume/investment-resume.component';
import { ConfirmEnableWarrantyComponent } from './checkout/dialogs/confirm-enable-warranty/confirm-enable-warranty.component';
import { SuccessActionResultComponent } from './checkout/dialogs/success-action-result/success-action-result.component';
import { CheckoutFullscreenDialogWrapComponent } from './checkout/dialogs/checkout-fullscreen-dialog-wrap/checkout-fullscreen-dialog-wrap.component';
import { UnplannedCheckoutComponent } from './checkout/unplanned-checkout/unplanned-checkout.component';

import { LayerService } from '@toro/common/shared/services/LayerService';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { CheckoutStockGuard } from './../../guards/checkout-stock.guard';
import { DATE_FORMATS } from '@toro/common/shared/resources/date-formats';

import { GlobalModule } from '../../global.module';
import { ComponentsModule } from '../../components/components.module';
import { StockCardsModule } from '../stock-cards/stocks-cards.module';
import { WalletInvestmentResumeComponent } from './checkout-wallet/dialogs/wallet-investment-resume/wallet-investment-resume.component';
import { AppcuesModule } from '@toro/common/shared/services/appcues/appcues.module';
import { CheckoutSuitabilityDisclaimerModule } from '../../shared/components/checkout-suitability-disclaimer/checkout-suitability-disclaimer.module';
import { WithoutSuitabilityDisclaimerModule} from '../../shared/components/without-suitability-disclaimer/without-suitability-disclaimer.module';

import { SharedModule } from '../../shared/shared.module';

@NgModule({
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    imports: [
        GlobalModule,
        ComponentsModule,
        StockCardsModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        CommonModule,
        TrSpinnerButtonDirectiveModule,
        TooltipDirectiveModule,
        ElementCardsDirectiveModule,
        IfCblcDirectiveModule,
        HubNavModule,
        HubLogoModule,
        AlertMessageModule,
        TrWrapperTwoColumnsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        FooterModule,
        SvgIconModule,
        FirstNamePipeModule,
        DateISOStringPipeModule,
        MarkdownToHtmlPipeModule,
        TrLoadingOverlayModule,
        TrStepInputModule,
        TrAccordionModule,
        TrCheckboxModule,
        TrMoneyModule,
        TrPlannedCheckoutInputModule,
        TrConfirmButtonsModule,
        ViewinterceptorDirectiveModule,
        OverlaySimpleModule,
        IntDatePipeModule,
        AppcuesModule,
        ModalModule,
        SharedModule,
        CheckoutSuitabilityDisclaimerModule,
        WithoutSuitabilityDisclaimerModule,
        ArrowBackLinkModule
    ],
    declarations: [
        StockHomeComponent,
        DialogVideoComponent,
        SuccessActionResultComponent,
        CheckoutFullscreenDialogWrapComponent,
        PlannedCheckoutComponent,
        UnplannedCheckoutComponent,
        TrWarrantyUsageComponent,
        InvestmentResumeComponent,
        ConfirmEnableWarrantyComponent,
        WalletInvestmentResumeComponent
    ],
    providers: [
        LayerService,
        UtilitiesService,
        StocksMarketInteractionsService,
        CheckoutStockGuard,
        DecimalPipe,
        CurrencyPipe,
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
    ],
    entryComponents: [
        DialogVideoComponent,
        SuccessActionResultComponent,
        InvestmentResumeComponent,
        ConfirmEnableWarrantyComponent,
        WalletInvestmentResumeComponent,
    ],
})

export class StockModule {}
